import { event } from '@zillow/universal-analytics';
import { ZillowZHLFooter } from '@zillow/zhl-page-structure';
import React from 'react';

import { getGeneralCallZHL } from './common/analytics';
import { getPublicSettingsValues } from './services/api';
import { getMarkdownCMSDocument } from './services/max';
import queryParamsManager from './utils/queryParams';

const handleError = (message: string): void => {
    console.error('Footer error:', message);
};

const Footer: React.FC = () => {
    return (
        <ZillowZHLFooter
            onError={handleError}
            getPublicSettingsValues={getPublicSettingsValues}
            getMarkdownCMSDocument={getMarkdownCMSDocument}
            queryParameters={queryParamsManager.getQueryParameters()}
            onGeneralCallZHL={() => event(getGeneralCallZHL())}
        />
    );
};

export default Footer;
